<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="二维码字符串">
                    <el-input v-model="ERP_Code" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersByQRCode()" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table" style="height: calc(100% - 136px)">
            <div class="content-table-title">查询信息</div>
            <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label" v-if="count">
                <el-descriptions-item label="订单号">
                    {{ result.Orders_SN }}
                    <el-button type="primary" v-if="result.Orders_SN" @click="getAL()">查看详情</el-button>
                </el-descriptions-item>
                <el-descriptions-item label="ERP订单号">{{ result.Orders_ERPSN }}</el-descriptions-item>
                <el-descriptions-item label="订单时间">{{ result.Orders_SyncTime }}</el-descriptions-item>
                <el-descriptions-item label="客户名称">{{ result.Orders_CustomerName }}</el-descriptions-item>
            </el-descriptions>
        </div>
    </div>
</template>
<script>
export default {
    name: 'codeQueryserch',
    data() {
        return {
            ERP_Code: '',
            result: {
                Orders_SN: '',
                Orders_ERPSN: '',
                Orders_SyncTime: '',
                Orders_CustomerName: ''
            },
            loadingBtn: false,
            count: 0
        };
    },
    mounted() {},
    methods: {
        getAL() {
            alert('待开发');
        },
        /*
    列表查询
    */
        getOrdersByQRCode() {
            this.loadingBtn = true;
            this.$newsApi
                .getOrdersByQRCode({ ERP_Code: this.ERP_Code })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.count++;
                        if (res.data.data) {
                            this.result = res.data.data;
                        } else {
                            this.$message({
                                message: res.data.Resultinfo,
                                type: 'warning'
                            });
                        }
                    }
                })
                .finally(() => (this.loadingBtn = false));
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.custom-label {
    width: 150px;
}
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
/deep/.el-descriptions-item__label {
    text-align: right !important;
}
</style>